export default "__VITE_ASSET__Btc_1bWK__"